import React from 'react'
import { useTranslation } from 'react-i18next'

import styles from './MainPage.module.scss'
import { BalanceAction, BottlesUserParticipatedIn, TermsOfUse, UserBalance, UserSettingsMenu } from './components'

const MainPage = () => {
  const { t } = useTranslation()

  return (
    <div className={styles.wrapper}>
      <UserSettingsMenu />
      <TermsOfUse />

      <div className={styles.body}>
        <UserBalance />

        <div className={styles.links}>
          <BalanceAction variant='replenishment' text={t('main_page.replenish')} path='/replenishment' />
          <BalanceAction variant='transfer' text={t('main_page.send')} path='/sending' />
          <BalanceAction variant='bring_out' text={t('main_page.bring_out')} path='/withdrawal' />
        </div>

        <BottlesUserParticipatedIn className={styles.bottles} />
      </div>
    </div>
  )
}

export default MainPage
